import { combineEpics } from "redux-observable";
import { epicGameTrackingFpsMemoryUsageGameJoined } from "./epicGameTrackingFpsMemoryUsageGameJoined";
import { epicGameTrackingFpsMemoryUsagePlayTime } from "./epicGameTrackingFpsMemoryUsagePlayTime";
import { epicGameTrackingFpsMemoryUsageTutorialFirstButtonClick } from "./epicGameTrackingFpsMemoryUsageTutorialFirstButtonClick";
import { epicGameTrackingFpsMemoryUsageTutorialStarted } from "./epicGameTrackingFpsMemoryUsageTutorialStarted";
export var epicGameTrackingFpsAndMemoryUsage = combineEpics(epicGameTrackingFpsMemoryUsageGameJoined, epicGameTrackingFpsMemoryUsageTutorialStarted, epicGameTrackingFpsMemoryUsageTutorialFirstButtonClick, epicGameTrackingFpsMemoryUsagePlayTime);



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/fps/epics/epicGameTrackingFpsAndMemoryUsage.ts
// module id = 1862
// module chunks = 3